import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { registerActions } from "../slices";
import { showSuccessToast } from "@helpers";

function* registerWorker({ payload }) {
  try {
    yield put(registerActions.pending());
    const response = yield call(authApi.register, payload);
    yield put(registerActions.success(response));
    // TODO: handle callback | onSuccess
    showSuccessToast("Create account successfully");
  } catch (error) {
    yield put(registerActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { registerWorker };
